import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  AGENDA_CATEGORY_COUNT,
  AGENDA_CATEGORY_LIST,
  AGENDA_SOLUTIONS_LIST_CLOSE_LOGIC,
  API_URL_SEARCH_RECOMMEND,
} from 'manager/http-constants';
import { Table } from 'primeng/table';
import { DICVALUES_API_CONSTANT } from 'src/app/shared/constant/api-constant';
import {CONSTANT, DEFAULT_PAGINATION_EVENT, NUMBER} from 'src/app/shared/constant/constant';
import { LoadingState } from 'src/app/shared/html-parts/loading/loading-state';
import { CommonService } from 'src/app/shared/service/common.service';
import { DbOperationService } from 'src/app/shared/service/db-operation.service';
import { PlatformComponent } from '../platform.component';
import { FollowDialogComponent } from 'src/app/pages/platform/common/follow-dialog/follow-dialog.component';
import { LoginService } from 'src/app/shared/service/login.service';
import { MESSAGE_CODE } from 'src/app/shared/constant/message-constant';
import { SESSION_KEY } from 'src/app/shared/constant/session-constants';
import { IssueDetailDialogComponent } from 'src/app/pages/platform/common/issue-detail-dialog/issue-detail-dialog.component';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-c201',
  templateUrl: './c201.component.html',
  styleUrls: ['./c201.component.scss', '../platform.component.scss'],
})

/**
 * 課題・ソリューション一覧
 */
export class C201Component extends PlatformComponent {
  @ViewChild(FollowDialogComponent)
  followDialogComponent: FollowDialogComponent;
  @ViewChild(IssueDetailDialogComponent)
  issueDetailDialogComponent: IssueDetailDialogComponent;

  // 画面.検索フォーム
  c201SearchForm: FormGroup = this.formBuilder.group({
    // フリーワード検索
    freeword: CONSTANT.EMPTY_STRING,
    // 課題・ソリューション種別
    agenda_kbn: CONSTANT.EMPTY_STRING,
    // 会員種別
    class_id: CONSTANT.EMPTY_STRING,
    // カテゴリ
    category: CONSTANT.EMPTY_STRING,
    // 地域
    prefectures: CONSTANT.EMPTY_STRING,
    // 更新日
    strdate: CONSTANT.EMPTY_STRING,
    // 更新日
    enddate: CONSTANT.EMPTY_STRING,
    // 業種
    industry_id: CONSTANT.EMPTY_STRING,
    // めざすゴール
    sdgs_goal: CONSTANT.EMPTY_STRING,
    // fpt added: search for followed isssue
    is_followed: CONSTANT.EMPTY_STRING,

    member_id: this.loginUser ? this.loginUser.member_id : '0'
  });

  /** テーブル状態 */
  @ViewChild('table') table: Table;

  // 課題・ソリューション種別のAccordion開閉フラグ
  accordion_agenda_kbn = false;

  // 会員種別のAccordion開閉フラグ
  accordion_class_id = false;

  // カテゴリのAccordion開閉フラグ
  accordion_category = false;

  // カテゴリの中項目Accordion開閉フラグ
  accordion_category_detail = new Map();

  // 都道府県のAccordion開閉フラグ
  accordion_prefectures = false;

  // 都道府県の中項目Accordion開閉フラグ
  accordion_prefectures_detail = new Map();

  // 更新日のAccordion開閉フラグ
  accordion_update_date = false;

  // 業種のAccordion開閉フラグ
  accordion_industry_id = false;

  // SDGsゴールのAccordion開閉フラグ
  accordion_sdgs_goal = false;

  // 課題・ソリューション結果リスト
  resultTaskDataList: object[] = [];

  // 課題・ソリューション結果リストトータル
  totalRecords = 0;

  // 課題・ソリューション件数格納先
  countTaskData = 0;

  // セッション保存名
  sessionTagName = 'c201SearchConditions';

  // fpt added: checkbox filter followed status
  isFilterFollowed = false;

  // レコメンド結果リスト
  resultRecommendList: object[] = [];

  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private router: Router,
    private formBuilder: FormBuilder,
    private loginService: LoginService,
    private titleService: Title
  ) {
    super(route, commonService, dbOperationService, loadingState);
    this.titleService.setTitle('地方創生SDGs官民連携マッチングシステム｜内閣府');
  }

  ngOnInit(): void {
    // 辞書値リストを取得
    this.getSpecCodeList(1, 2, 3);

    // 課題カテゴリを取得
    this.getAgendaCategoryList();

    // 初期処理:クエリパラメータの設定
    this.setQueryParams();

    this.loginService.getAuth0LoginState().subscribe((response) => {
      // ログイン状態をセット

      // ログイン状態を判定
      if (response) {
        // ログイン状態の場合

        /* ログインユーザー情報 */
        // セッションからログインユーザ情報取得
        const loginUser = JSON.parse(
          window.sessionStorage.getItem(SESSION_KEY.loginUserInformation)
        );

        // セッションにログインユーザ情報が存在するか否か
        if (loginUser) {
          // セッションにログインユーザが存在する場合

          // 課題・ソリューション結果を取得
          this.getResultTaskDataList(false);
          return;
        } else {
          // セッションにログインユーザが存在しない場合(初回表示時)

          // ログインユーザ情報取得処理
          this.loginService.getLoginUser().subscribe((response) => {
            // 正常なユーザの為、セッションにユーザ情報を格納
            window.sessionStorage.setItem(
              SESSION_KEY.loginUserInformation,
              JSON.stringify(response.body[0])
            );

            this.loginUser = JSON.parse(window.sessionStorage.getItem(SESSION_KEY.loginUserInformation));
            this.c201SearchForm.get('member_id').setValue(this.loginUser.member_id);
            // 課題・ソリューション結果を取得
            this.getResultTaskDataList(false);
            return;
          });
        }
      } else {
        // 未ログイン状態の場合

        this.getResultTaskDataList(false);
        return;
      }
    });

    // 代行会員情報を初期化
    this.initAltUserBySecretariat();
  }

  /**
   * 初期処理:クエリパラメータの設定
   */
  private setQueryParams(): void {
    // クエリパラメータ.課題・ソリューション種別
    {
      // クエリパラメータ.課題・ソリューション種別を取得
      const agendaKbn = this.route.snapshot.queryParams.agenda_kbn;

      // 課題・ソリューション種別が存在するか否か
      if (agendaKbn) {
        // 課題・ソリューション種別が存在する場合

        // 課題・ソリューション種別を画面.検索フォームに格納
        this.c201SearchForm
          .get('agenda_kbn')
          .setValue(agendaKbn.split(CONSTANT.COMMA));

        // 課題・ソリューション種別のAccordionを開く
        this.accordion_agenda_kbn = true;
      }
    }

    // クエリパラメータ.会員種別
    {
      // クエリパラメータ.会員種別を取得
      const classId = this.route.snapshot.queryParams.class_id;

      // 会員種別が存在するか否か
      if (classId) {
        // 会員種別が存在する場合

        // 会員種別を画面.検索フォームに格納
        this.c201SearchForm
          .get('class_id')
          .setValue(classId.split(CONSTANT.COMMA));

        // 会員種別のAccordionを開く
        this.accordion_class_id = true;
      }
    }

    // クエリパラメータ.カテゴリ
    {
      // クエリパラメータ.カテゴリを取得
      const category = this.route.snapshot.queryParams.category;

      // カテゴリが存在するか否か
      if (category) {
        // カテゴリが存在する場合

        // カテゴリを画面.検索フォームに格納
        this.c201SearchForm
          .get('category')
          .setValue(category.split(CONSTANT.COMMA));

        // カテゴリのAccordionを開く
        this.accordion_category = true;
      }
    }
  }

  /**
   * 課題・ソリューション結果を取得
   */
  public getResultTaskDataList(screenSearchFlg: boolean, event: any = DEFAULT_PAGINATION_EVENT): void {
    // 画面.検索フォームから検索条件を取得
    // ※値渡し
    let c201SearchForm: any = JSON.parse(
      JSON.stringify(this.c201SearchForm.value)
    );

    const pageNo = event.first / event.rows + 1;
    const pageSize = event.rows;

    c201SearchForm.page_no = pageNo;
    c201SearchForm.page_size = pageSize;

    // レコメンド検索用フォーム
    let c201SearchRecommendForm;
    // 検索フォームが空の場合、セッションに保持している検索条件を設定
    if (!this.checkSetConditions(c201SearchForm) && !screenSearchFlg) {
      const sessionSearchForm = JSON.parse(sessionStorage.getItem(this.sessionTagName));
      // セッションに値がなければ設定しない
      if (this.checkSetConditions(sessionSearchForm)) {
        if (!this.loginUser){
          sessionSearchForm.member_id = '0';
        }else{
          sessionSearchForm.member_id = this.loginUser.member_id;
        }
        // 画面の検索条件に反映する
        this.c201SearchForm.setValue(sessionSearchForm);
        // 検索条件に設定する
        c201SearchForm = JSON.parse(
          JSON.stringify(this.c201SearchForm.value)
        );
        // fpt added set search condition
        this.isFilterFollowed = c201SearchForm.is_followed  == 1;
        // 検索条件を元にアコーディオンの開閉フラグを設定
        this.setAccordionFlg(c201SearchForm);
      }
    }

    // 検索条件の地域が配列か否か
    if (c201SearchForm.prefectures) {
      // 検索条件の地域が配列の場合

      // 検索条件の地域から大項目(local_category)を削除する
      c201SearchForm.prefectures = c201SearchForm.prefectures.filter(
        (prefectures) => !prefectures.includes('local_category_')
      );
    }

    // 配列をカンマ区切り変換
    {
      // 課題・ソリューション種別
      c201SearchForm.agenda_kbn = c201SearchForm.agenda_kbn
        ? c201SearchForm.agenda_kbn.toString()
        : CONSTANT.EMPTY_STRING;

      // 会員種別
      c201SearchForm.class_id = c201SearchForm.class_id
        ? c201SearchForm.class_id.toString()
        : CONSTANT.EMPTY_STRING;

      // カテゴリ
      c201SearchForm.category = c201SearchForm.category
        ? c201SearchForm.category.toString()
        : CONSTANT.EMPTY_STRING;

      // 地域
      c201SearchForm.prefectures = c201SearchForm.prefectures
        ? c201SearchForm.prefectures.toString()
        : CONSTANT.EMPTY_STRING;

      // 業種
      c201SearchForm.industry_id = c201SearchForm.industry_id
        ? c201SearchForm.industry_id.toString()
        : CONSTANT.EMPTY_STRING;

      // めざすゴール
      c201SearchForm.sdgs_goal = c201SearchForm.sdgs_goal
        ? c201SearchForm.sdgs_goal.toString()
        : CONSTANT.EMPTY_STRING;

      // レコメンド検索用に値を格納
      if (!this.loginUser){
        c201SearchRecommendForm = { member_id: '0',
          agenda_kbn: c201SearchForm.agenda_kbn, category: c201SearchForm.category };
      }else{
        c201SearchRecommendForm = { member_id: this.loginUser.member_id,
          agenda_kbn: c201SearchForm.agenda_kbn, category: c201SearchForm.category };
      }
    }

    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(AGENDA_SOLUTIONS_LIST_CLOSE_LOGIC);

    // 課題・ソリューション一覧を取得
    this.dbOperationService
      .getNoTemplateData(AGENDA_SOLUTIONS_LIST_CLOSE_LOGIC, c201SearchForm, true)
      .subscribe((response) => {
        if (!this.commonService.checkNoneResponse(response)) {
          // 課題・ソリューション結果を格納
          this.resultTaskDataList = response.body.records;
          this.totalRecords = response.body.total_records;
        } else {
          this.resultTaskDataList = [];
        }
        // 検索条件を保持
        sessionStorage.setItem(this.sessionTagName, JSON.stringify(this.c201SearchForm.value));

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, AGENDA_SOLUTIONS_LIST_CLOSE_LOGIC);
      });

    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(AGENDA_CATEGORY_COUNT);

    // 課題・ソリューション件数を取得
    this.dbOperationService
      .getNoTemplateData(AGENDA_CATEGORY_COUNT, null, true)
      .subscribe((response) => {
        // 課題・ソリューション件数を格納
        this.countTaskData = response.body.count;

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, AGENDA_CATEGORY_COUNT);
      });

    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(API_URL_SEARCH_RECOMMEND);

    // レコメンド一覧を取得
    this.dbOperationService
      .getNoTemplateData(API_URL_SEARCH_RECOMMEND, c201SearchRecommendForm)
      .subscribe((response) => {
        if (!this.commonService.checkNoneResponse(response)) {
          // レコメンド一覧を格納
          this.resultRecommendList = response.body;
        } else {
          this.resultRecommendList = [];
        }
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, API_URL_SEARCH_RECOMMEND);
      });

    // 検索時にページアンカーへ遷移
    if (screenSearchFlg) {
      this.jumpTop();
      // テーブル状態をリセットする
      this.table.first = 0;
    }
  }

  /**
   * カテゴリ大項目
   * @param e チェック状態
   * @param list チェック対象小項目リスト
   */
  public checkLargeCategory(e: any, list: any): void {

    // 親イベントを止める(ヘッダ開閉)
    event.stopPropagation();

    // 画面.検索フォーム.カテゴリを取得
    const getList = this.c201SearchForm.get('category').value;

    // チェック対象小項目リストからコード値のみ取得
    const spCodeList = this.commonService.createArrayGetArrayObject(
      list,
      'value'
    );

    // 該当のカテゴリコードを全て削除してresult変数に格納
    let result = getList.filter((value) => !spCodeList.includes(value));

    // チェック状態の判定
    if (e.checked) {
      // チェック状態の場合

      // result変数に選択したカテゴリコードリストを追加
      result = result.concat(spCodeList);
    }

    // 画面.検索フォーム.地域に設定
    this.c201SearchForm.get('category').setValue(result);
  }

  /**
   * カテゴリ中項目
   * @param event チェック状態
   * @param code 大項目コード
   * @param list チェック対象小項目リスト
   */
  public checkMediumCategory(event: any, code: string, list: any): void {
    // 画面.検索フォーム.カテゴリを取得
    const getList = this.c201SearchForm.get('category').value;

    // チェック状態の判定
    if (event.checked) {
      // チェック状態の場合

      // チェック対象小項目リストからコード値のみ取得
      const spCodeList = this.commonService.createArrayGetArrayObject(
        list,
        'value'
      );

      // チェック対象小項目リストが全てチェック状態の場合
      if (spCodeList.every((spCode) => getList.indexOf(spCode) != -1)) {
        // 画面.検索フォーム.カテゴリに大項目コードを追加
        getList.push(code);

        // 画面.検索フォーム.カテゴリに設定
        this.c201SearchForm.get('category').setValue(getList);
      }
    } else {
      // 非チェック状態の場合

      // 画面.検索フォーム.カテゴリから大項目コードを削除
      this.c201SearchForm
        .get('category')
        .setValue(getList.filter((value) => value != code));
    }
  }

  /**
   * 地域大項目
   * @param event チェック状態
   * @param list チェック対象小項目リスト
   */
  public checkLargePrefectures(e: any, list: any): void {

    // 親イベントを止める(ヘッダ開閉)
    event.stopPropagation();

    // 画面.検索フォーム.地域を取得
    const getList = this.c201SearchForm.get('prefectures').value;

    // チェック対象小項目リストからコード名称のみ取得
    const spCodeList = this.commonService.createArrayGetArrayObject(
      list,
      DICVALUES_API_CONSTANT.SP_NAME
    );

    // 該当の地域コードを全て削除してresult変数に格納
    let result = getList.filter((value) => !spCodeList.includes(value));

    // チェック状態の判定
    if (e.checked) {
      // チェック状態の場合

      // result変数に選択した地域コードリストを追加
      result = result.concat(spCodeList);
    }

    // 画面.検索フォーム.地域に設定
    this.c201SearchForm.get('prefectures').setValue(result);
  }

  /**
   * 地域中項目
   * @param event チェック状態
   * @param code 大項目コード
   * @param list チェック対象小項目リスト
   */
  public checkMediumPrefectures(event: any, code: string, list: any): void {
    // 画面.検索フォーム.地域を取得
    const getList = this.c201SearchForm.get('prefectures').value;

    // チェック状態の判定
    if (event.checked) {
      // チェック状態の場合

      // チェック対象小項目リストからコード名称のみ取得
      const spCodeList = this.commonService.createArrayGetArrayObject(
        list,
        DICVALUES_API_CONSTANT.SP_NAME
      );

      // チェック対象小項目リストが全てチェック状態の場合
      if (spCodeList.every((spCode) => getList.indexOf(spCode) != -1)) {
        // 画面.検索フォーム.地域に大項目コードを追加
        getList.push(code);

        // 画面.検索フォーム.地域に設定
        this.c201SearchForm.get('prefectures').setValue(getList);
      }
    } else {
      // 非チェック状態の場合

      // 画面.検索フォーム.地域から大項目コードを削除
      this.c201SearchForm
        .get('prefectures')
        .setValue(getList.filter((value) => value != code));
    }
  }

  /**
   * 課題・ソリューション詳細(C301)へ遷移する
   * @param agendaId 課題ID
   */
  public moveC301(agendaId: string): void {
    // 課題・ソリューション詳細(C301)へ遷移
    this.router.navigate(['pages/platform/c301/' + agendaId]);
  }

  /**
   * 課題・ソリューション詳細(C301)または連携事例詳細(H301)を別タブで表示する
   * @param kbn 区分(1：課題, 2：ソリューション, 3：連携事例)
   * @param id ID
   */
  public moveC301orMoveH301(kbn: string, id: string): void {

    // 課題・ソリューション or 連携事例か
    if ('1' == kbn || '2' == kbn) {
      // 課題・ソリューション詳細(C301)へ遷移
      if ('1' == kbn){
        if (this.loginUser){
          const newwin = window.open('pages/platform/c301/' + id);
        }else{
          this.showDetailIssueDialog(id, true);
        }
      }else{
        const newwin = window.open('pages/platform/c301/' + id);
      }
    } else {
      // 連携事例詳細(H301)へ遷移
      const newwin = window.open('pages/platform/h301/' + id);
    }
  }

  /**
   * 検索条件が設定されているかチェックする
   * @param conditions
   * @returns boolean true:設定あり / false:未設定
   */
  public checkSetConditions(conditions: any): boolean {
    // 検索条件が存在するかチェック
    if (conditions === undefined || conditions === null) {
      return false;
    } else {
      // 検索条件が設定されているかチェック
      if (conditions.freeword || conditions.agenda_kbn || conditions.class_id ||
        conditions.category || conditions.prefectures || conditions.strdate ||
        conditions.enddate || conditions.industry_id || conditions.sdgs_goal) {
        return true;
      }
    }
    return false;
  }

  /**
   * 値NULL判定
   */
  public checkNull(val: any, attr_first: string, attr_second?: string): any {
    if (val == null || typeof val === 'undefined' || !Object.keys(val).length) {
      return null;
    }
    return attr_second == null ? val[attr_first] : val[attr_first][attr_second];
  }

  /**
   * アコーディオン表示フラグ設定
   */
  public setAccordionFlg(formVal: any): void {
    // 課題ソリューション種別
    this.accordion_agenda_kbn = (formVal.agenda_kbn != null && formVal.agenda_kbn?.length != 0) ? true : false;
    // 会員種別
    this.accordion_class_id = (formVal.class_id != null && formVal.class_id?.length != 0) ? true : false;
    // 地域
    this.accordion_prefectures = (formVal.prefectures != null && formVal.prefectures?.length != 0) ? true : false;
    // 地域 中項目
    if (this.accordion_prefectures) {
      for (let i = 0; i < this.prefecturesList.length; i++) {
        for (let j = 0; j < this.prefecturesList[i].list.length; j++) {
          if (formVal.prefectures.indexOf(this.prefecturesList[i].list[j].sp_name) != -1) {
            this.accordion_prefectures_detail[this.prefecturesList[i].code] = true;
            break;
          }
        }
      }
    }
    // カテゴリ
    this.accordion_category = (formVal.category != null && formVal.category?.length != 0) ? true : false;
    // カテゴリ 中項目
    if (this.accordion_category) {
      // 課題カテゴリを取得
      this.dbOperationService
        .getNoTemplateData(AGENDA_CATEGORY_LIST, null, true)
        .subscribe((response) => {
          if (!this.commonService.checkNoneResponse(response)) {
            const categorysList = response.body;
            for (let i = 0; i < categorysList.length; i++) {
              for (let j = 0; j < categorysList[i].rec.length; j++) {
                if (formVal.category.indexOf(categorysList[i].rec[j].value) != -1) {
                  this.accordion_category_detail[categorysList[i].class_cd1] = true;
                  break;
                }
              }
            }
          }
        });
    }
    // 更新日
    this.accordion_update_date = (formVal.strdate != null && formVal.strdate?.length != 0) ? true :
      (formVal.enddate != null && formVal.enddate?.length != 0) ? true : false;
    // 業種
    this.accordion_industry_id = (formVal.industry_id != null && formVal.industry_id?.length != 0) ? true : false;
    // SDGsゴール
    this.accordion_sdgs_goal = (formVal.sdgs_goal != null && formVal.sdgs_goal?.length != 0) ? true : false;
  }

  /**
   * open dialog follow
   * @param agendaId agenda to follow
   * @param member_id created member id
   * @param agendaTitle title to display
   * @returns
   */
  openConfirmFollowdialog(agendaId: string, member_id: string, agendaTitle: string){
    if (!this.loginUser || this.loginUser.class_id != 9 || this.loginUser.class_id != 3){
      this.followDialogComponent.showConfirmFollowDialog(agendaId, agendaTitle, member_id);
    }
  }

  /**
   * open dialog unfollow
   * @param agendaId agenda to unfollow
   * @param agendaTitle agenda title to display
   * @returns
   */
  openConfirmUnFollowdialog(agendaId: string, agendaTitle: string){
    this.followDialogComponent.showConfirmUnFollowDialog(agendaId, agendaTitle);
  }

  /**
   * search filtered by following status
   * @param event on checkbox value change event
   */
  changeFilterFollowed(event){
    this.c201SearchForm.get('is_followed').setValue(event.checked ? '1' : '0');
    this.getResultTaskDataList(true);
  }
  /**
   * reset searchform and set appropirate initial value
   */
  resetSearchForm(){
    this.c201SearchForm.reset();
    this.c201SearchForm.get('member_id').setValue(this.loginUser ? this.loginUser.member_id : '0');
    this.c201SearchForm.get('is_followed').setValue(this.isFilterFollowed ? '1' : '0');
  }
  showDetailIssueDialog(agenda_id: string, isOpenInNewTab: boolean = false){
    this.issueDetailDialogComponent.showDialog(agenda_id, isOpenInNewTab);
  }
  showIssueDialog(agenda_id: string, agenda_kbn: string){
    if (agenda_kbn != '2' && !this.loginUser){
        this.showDetailIssueDialog(agenda_id);
    }
  }

  generateAgendaUrl(agendaId: string, agendaKbn: string): string {
    if (agendaKbn == '2'){
      return `pages/platform/c301/${agendaId}`;
    }else {
      if (this.loginUser) {
        return `pages/platform/c301/${agendaId}`;
      }
    }
  }
}
